// extracted by mini-css-extract-plugin
module.exports = {"action-buttons":"appointee-management_action-buttons__20upJ"};